module.exports = __webpack_public_path__ + "annualreview2017/static/img/power-supply-from-national-grid@0,5x.2ae3e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscape/power-supply-from-national-grid@0,5x.png
// module id = 758
// module chunks = 0